module.exports = __webpack_public_path__ + "static/media/adobeXD.1ce78980.svg";